import React from "react";

const UserReportViewSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      {/* Header section with case ID and status */}
      <div className="bg-gray-300 animate-pulse p-6 rounded-t-lg">
        <div className="flex justify-between items-center flex-wrap gap-3">
          <div>
            <div className="h-4 w-32 bg-gray-400 animate-pulse rounded"></div>
            <div className="h-7 w-40 bg-gray-400 animate-pulse rounded mt-2"></div>
          </div>
          <div className="flex flex-col items-end">
            <div className="h-6 w-28 bg-gray-400 animate-pulse rounded-full"></div>
            <div className="h-4 w-36 bg-gray-400 animate-pulse rounded mt-2"></div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {/* Basic case information */}
        <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-5 w-5 bg-gray-300 animate-pulse rounded-full"></div>
            <div className="h-5 w-40 bg-gray-300 animate-pulse rounded"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((item) => (
              <div key={`case-${item}`} className="mb-4">
                <div className="h-4 w-24 bg-gray-200 animate-pulse rounded mb-2"></div>
                <div className="h-6 w-full bg-gray-300 animate-pulse rounded"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Location information */}
        <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-5 w-5 bg-gray-300 animate-pulse rounded-full"></div>
            <div className="h-5 w-36 bg-gray-300 animate-pulse rounded"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2].map((item) => (
              <div key={`location-${item}`} className="mb-4">
                <div className="h-4 w-28 bg-gray-200 animate-pulse rounded mb-2"></div>
                <div className="h-6 w-full bg-gray-300 animate-pulse rounded"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Incident description */}
        <div className="bg-white p-6 rounded-lg shadow-sm md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-5 w-5 bg-gray-300 animate-pulse rounded-full"></div>
            <div className="h-5 w-32 bg-gray-300 animate-pulse rounded"></div>
          </div>

          <div className="mb-4">
            <div className="h-4 w-24 bg-gray-200 animate-pulse rounded mb-2"></div>
            <div className="h-24 w-full bg-gray-300 animate-pulse rounded"></div>
          </div>

          {/* Evidence section */}
          <div className="mt-6">
            <div className="h-5 w-24 bg-gray-300 animate-pulse rounded mb-4"></div>

            {/* Voice narration placeholder */}
            <div className="mb-6">
              <div className="h-4 w-28 bg-gray-200 animate-pulse rounded mb-2"></div>
              <div className="h-12 w-full bg-gray-300 animate-pulse rounded"></div>
            </div>

            {/* Photo evidence placeholder */}
            <div className="mb-6">
              <div className="h-4 w-28 bg-gray-200 animate-pulse rounded mb-2"></div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {[1, 2, 3].map((item) => (
                  <div
                    key={`evidence-${item}`}
                    className="aspect-square bg-gray-300 animate-pulse rounded"
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Reporter information */}
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-5 w-5 bg-gray-300 animate-pulse rounded-full"></div>
            <div className="h-5 w-32 bg-gray-300 animate-pulse rounded"></div>
          </div>

          {[1, 2, 3, 4].map((item) => (
            <div key={`reporter-${item}`} className="mb-4">
              <div className="h-4 w-20 bg-gray-200 animate-pulse rounded mb-2"></div>
              <div className="h-6 w-full bg-gray-300 animate-pulse rounded"></div>
            </div>
          ))}
        </div>

        {/* Abuser information */}
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-5 w-5 bg-gray-300 animate-pulse rounded-full"></div>
            <div className="h-5 w-36 bg-gray-300 animate-pulse rounded"></div>
          </div>

          {[1, 2, 3, 4].map((item) => (
            <div key={`abuser-${item}`} className="mb-4">
              <div className="h-4 w-24 bg-gray-200 animate-pulse rounded mb-2"></div>
              <div className="h-6 w-full bg-gray-300 animate-pulse rounded"></div>
            </div>
          ))}

          {/* Abuser photos placeholder */}
          <div className="mt-4">
            <div className="h-4 w-28 bg-gray-200 animate-pulse rounded mb-2"></div>
            <div className="grid grid-cols-2 gap-2">
              {[1, 2].map((item) => (
                <div
                  key={`abuser-photo-${item}`}
                  className="aspect-square bg-gray-300 animate-pulse rounded"
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserReportViewSkeleton;
